module.exports = __webpack_public_path__ + "static/media/256.61bf175b.webp";